Application.Postcard.Confirm = {
    ui: {
        container: '.js-postcard-confirm',
        resentSuccess: '.js-postcard-confirm__resent-success',
    },
    previewList: null,
    svgIcon: null,
    current: null,
    ready: function () {

        if (!$(this.ui.container).length){
            return;
        }

    },
    resent: function(){

        var self = this;

        $(this.ui.resentSuccess).removeClass('active');

        setTimeout(function(){
            $(self.ui.resentSuccess).addClass('active');
        },50);

    }
};